<template>
	<div class="details-value-view">
		<span class="details-value-content">
			<details-value-source :source="detailsValue.source"/>

			<span
				v-if="isEmployeeDetailsValue(detailsValue) && detailsValue.previousMonth"
				v-tooltip.right="$t('tooltip.previousMonth')"
				class="icon has-tooltip-right has-text-warning"
			>
				<span class="fas fa-exclamation-triangle" />
			</span>

			<span v-if="!detailsValue.reasonNotComplete" v-tooltip="readableDetailsValueFilter(detailsValue)">
				{{ detailsValue | readableDetailsValue }}
			</span>

			<span v-else class="tags has-addons">
				<span class="tag is-warning">
					{{ $t("not.complete") }}
				</span>
				<span class="tag is-light is-warning has-tooltip-right" v-tooltip.right="detailsValue.reasonNotComplete">
					<span class="icon"><span class="fas fa-comment"></span></span>
				</span>
			</span>
		</span>

		<span
			v-if="copyDsn || copyPaySlip"
			class="details-value-actions"
			:class="showDate && 'mr-2'"
		>
			<button
				v-if="copyDsn"
				class="button is-small mb-0 has-tooltip-top has-tooltip-left"
				v-tooltip.top-end="$t('tooltip.copyDsn', { value: detailsValue.dsnValue })"
				@click="$emit('copy', 'DSN', detailsValue)"
			>
				<span class="icon"><span class="fas fa-copy"></span></span>
				<span v-t="'action.copyDsn'"></span>
			</button>
			<button
				v-if="copyPaySlip"
				class="button is-small mb-0 has-tooltip-top has-tooltip-left"
				v-tooltip.top-end="$t('tooltip.copyPaySlip', { value: detailsValue.paySlipValue })"
				@click="$emit('copy', 'PAY_SLIP', detailsValue)"
			>
				<span class="icon"><span class="fas fa-copy"></span></span>
				<span v-t="'action.copyPaySlip'"></span>
			</button>
		</span>

		<small
			v-if="showDate"
			class="details-value-date"
			v-t="{
				path: 'date.period',
				args: { date: $options.filters && $options.filters.date(detailsValue.datePeriod, { day: 'numeric', month: 'long' }) }
			}"
		></small>
	</div>
</template>

<script lang="ts">
import DetailsValueSource from "@/components/form/vues/details/DetailsValueSource.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

import { EmployeeDetailsValueRepresentation, InstitutionDetailsValueRepresentation } from "@/lib/apis/replicable/models";
import { filter as readableDetailsValueFilter } from "@/filters/ReadableDetailsValue";

type ModelDetails = EmployeeDetailsValueRepresentation | InstitutionDetailsValueRepresentation;

@Component({
	components: {
		DetailsValueSource
	}
})
export default class DetailsValueView extends Vue {
	@Prop({ required: true })
	public readonly detailsValue!: ModelDetails;

	@Prop({ type: Boolean, default: true })
	public readonly showDate!: boolean;

	public readableDetailsValueFilter = readableDetailsValueFilter;

	public get copyDsn(): boolean {
		return !!this.detailsValue.dsnValue && this.detailsValue.dsnValue !== this.detailsValue.value;
	}

	public get copyPaySlip(): boolean {
		return !!this.detailsValue.paySlipValue && this.detailsValue.paySlipValue !== this.detailsValue.value;
	}

	public isEmployeeDetailsValue(detailsValue: ModelDetails): detailsValue is EmployeeDetailsValueRepresentation {
		return (detailsValue as EmployeeDetailsValueRepresentation).previousMonth !== undefined;
	}
}
</script>

<i18n src="../../i18n/Details.json"></i18n>
